import { useValidationYupDocumento } from 'utils/form-validations';
import { stringNumeros } from 'utils/string-numeros';
import * as Yup from 'yup';

export const useFormCampoIdentificacaoValidation = (name: string, isNotOpcional?: boolean) => {

    const validationTelefone = () => {
        return Yup.string().test({
            message: 'Formato Inválido',
            test: (value) => {
                if (!value && !isNotOpcional) return true
                return Boolean(value && (stringNumeros(value).length === 10 || stringNumeros(value).length === 11))
            }
        })
    }

    const { documentoYup } = useValidationYupDocumento(true)
    const formCampoIdentificacaoValidation = Yup.object().shape({
        [name]: name === "cpfCnpj"
            ? documentoYup()
            : name === "telefone"
                ? validationTelefone()
                : name === "nome" && isNotOpcional
                    ? Yup.string().required('Campo Obrigatório')
                    : Yup.string()
    });

    return {
        formCampoIdentificacaoValidation
    }
}